export default __webpack_public_path__ + "static/media/Blog.04a40008.png";